import React from "react";
import PropTypes from "prop-types";
import { isValidValue } from "utils/validators";

export const TotalCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span />;
  }
  return <span>{ `$${parseFloat(value / 100).toFixed(2)}` }</span>;
};

TotalCellFormatter.propTypes = {
  value: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/total-cell-formatter.jsx